import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import {
    setPbxPageMounted,
    setPbxPageUnmounted,
} from 'flow/actions/app-actions';
import { fetchQueueActiveProfile } from 'flow/actions/pbx-actions';
import OmniChannelMappings from 'flow/components/omni/OmniChannelMappings';
import Page from 'flow/components/Setting/Page';
import Divider from 'flow/components/ui-components/Divider';
import { QueueKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { selectIsSinglePaneMode } from 'flow/selectors/app-selectors';
import {
    selectQueueDescription,
    selectQueueIsOfTypeTicketsOmni,
} from 'flow/selectors/queue-selectors';
import ButtonQueueSettings from 'flow/components/pbx/queue/ButtonQueueSettings';
import QueueActiveProfile from 'flow/components/pbx/queue/QueueActiveProfile';
import QueueAgentStatisticsPreview from 'flow/components/pbx/queue/QueueAgentStatisticsPreview';
import QueueMembers from 'flow/components/pbx/queue/QueueMembers';
import QueueOwnMemberLogin from 'flow/components/pbx/queue/QueueOwnMemberLogin';
import QueuePhoneNumber from 'flow/components/pbx/queue/QueuePhoneNumber';
import SectionQueueItemsActive from 'flow/components/pbx/v2/pbx-queue-items/active/SectionQueueItemsActive';
import SectionQueueItemsHistory from 'flow/components/pbx/v2/pbx-queue-items/history/SectionQueueItemsHistory';
import { QUEUE_PAGE_SCROLLER_ID } from 'flow/components/pbx/v2/pbx-queue-items/history/queue-scroll-position';

const PbxQueueV2 = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { entityKey: queueKey } = useParams<{ entityKey: QueueKey }>();
    const isSinglePaneMode = useAppSelector(selectIsSinglePaneMode);
    const queueName = useAppSelector((state) =>
        selectQueueDescription(state, queueKey),
    );
    const queueIsOfTypeTicketsOmni = useAppSelector((state) =>
        selectQueueIsOfTypeTicketsOmni(state, queueKey),
    );

    useEffect(() => {
        fetchQueueActiveProfile(queueKey);
    }, [queueKey]);

    useEffect(() => {
        dispatch(setPbxPageMounted(queueKey));
        return () => {
            dispatch(setPbxPageUnmounted(queueKey));
        };
    }, [dispatch, queueKey]);

    return (
        <Page
            header={queueName || ''}
            onClickBack={
                isSinglePaneMode ? () => history.push(routes['pbx']) : undefined
            }
            action={<ButtonQueueSettings queueKey={queueKey} />}
            childrenClassName="w-full p-0 !-mt-0"
            mainId={QUEUE_PAGE_SCROLLER_ID}
            mainClassName="scrollbar-gutter-stable pt-0"
        >
            <QueueAgentStatisticsPreview queueKey={queueKey} />
            <div className="mx-auto w-full max-w-screen-sm bg-white py-2 ps-2 pe-1 antialiased">
                <QueuePhoneNumber queueKey={queueKey} />
                {queueIsOfTypeTicketsOmni ? (
                    <OmniChannelMappings queueKey={queueKey} />
                ) : null}
                <QueueActiveProfile queueKey={queueKey} />
                <QueueOwnMemberLogin queueKey={queueKey} />
                <QueueMembers queueKey={queueKey} />
                <Divider />
                <SectionQueueItemsActive queueKey={queueKey} />
                <SectionQueueItemsHistory queueKey={queueKey} />
            </div>
        </Page>
    );
};

export default PbxQueueV2;
